// Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// Libraries
import * as objectPath from 'object-path';
import _ from 'lodash-es';

@Injectable()
export class PageConfigService {
	pageConfig: any;

	constructor(private router: Router) {}

	getCurrentPageConfig(path?: string): any {
		let configPath = this.cleanUrl(this.router.url);

		if (path) {
			configPath += '.' + path;
		}

		// get page config by path
		return objectPath.get(this.pageConfig, configPath);
	}

	setConfig(value: any, save?: boolean) {
		this.pageConfig = _.merge(this.pageConfig, value);

		if (save) {
			// not implemented
		}
	}

	loadConfigs(config: any) {
		this.pageConfig = config;
	}

	cleanUrl(url: string): string {
		// remove first route (demo name) from url router
		if (new RegExp(/^\/demo/).test(url)) {
			const urls = url.split('/');
			urls.splice(0, 2);
			url = urls.join('/');
		}

		if (url.charAt(0) == '/') {
			url = url.substr(1);
		}

		// we get the page title from config, using url path.
		// we need to remove query from url ?id=1 before we use the path to search in array config.
		let finalUrl = url.replace(/\//g, '.');
		if (finalUrl.indexOf('?') !== -1) {
			finalUrl = finalUrl.substring(0, finalUrl.indexOf('?'));
		}

		return finalUrl;
	}
}
